<template slot="responsiveRight">
  <b-collapse :id="idName" :accordion="accordianName" :class="'navbar-list'" :visible="open" tag="ul">
    <li v-for="(item, index) in items" :key="index" :class="
      item.is_heading
        ? 'nav-item'
        : activeLink(item) && item.children && item.children.length != 0
          ? 'active'
          : activeLink(item)
            ? 'active'
            : ''
    ">
      <a v-if="item.children && item.children.length != 0" class="search-toggle iq-waves-effect menu-icons" href="#">
        <div class="iq-icons-list title-typography-color">
          <i :class="item.icon"></i>
          <span class="name-title">{{ $t(item.i18n) }} </span>
        </div>

        <small :class="item.append_class" v-html="item.append" />
      </a>
      <router-link v-else v-b-toggle="item.name" :class="`iq-waves-effect menu-icons ${activeLink(item) && item.children && item.children.length != 0
        ? 'active'
        : activeLink(item)
          ? 'active'
          : ''
        }`" :to="item.link">
        <div class="iq-icons-list">
          <i :class="item.icon"></i>
          <span class="name-title">{{ item.title }}</span>
        </div>
        <small :class="item.append_class" v-html="item.append" />
      </router-link>
      <div v-if="item.children && item.children.length != 0" class="iq-sub-dropdown">
        <div class="iq-card m-0">
          <div class="iq-card-body p-0">
            <div class="text-w background-typography p-3 text-white">
              <h5 class="mb-0 text-white">{{ $t(item.i18n) }}</h5>
            </div>
            <router-link v-for="(item, index) in item.children" :key="index" v-b-toggle="item.name"
              :class="`iq-sub-card iq-bg-primary-hover`" :to="item.link">
              <div class="media align-items-center">
                <div class="rounded iq-card-icon background-typography text-white">
                  <i :class="item.icon"></i>
                </div>
                <div class="media-body ml-3">
                  <h6 class="mb-0">{{ $t(item.i18n) }}</h6>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </li>
    <li class="nav-item mobile-show" v-if="user">
      <a class="search-toggle iq-waves-effect" href="#">
        <b-avatar class="mr-2" size="2.5em" v-bind:src="
          user.avatarUrl
            ? user.avatarUrl +
            '/' +
            getAuthentication()
            : ''
        "></b-avatar>
      </a>
      <div class="iq-sub-dropdown iq-dropdown">
        <div class="iq-card shadow-none m-0">
          <div class="iq-card-body p-0">
            <div class="theme-color-navbar p-3 background-typography">
              <h5 class="mb-0 line-height text-white">
                {{ $t("public.layouts.HomeLayout.hi") }} {{ user.name }}
              </h5>
              <a v-if="user.role === 'PATIENT' && wallet.total !== undefined" class="text-white font-size-16"
                href="javascript:void(0)" @click="showWallet">
                {{ $t("public.layouts.HomeLayout.balance") }}:
                {{ wallet.total.toFixed(2) }} €
              </a>
              <span class="font-size-16 mr-2">
                <b-badge v-if="user.role === 'SUPERADMIN'" variant="danger">{{
                  $t("public.layouts.HomeLayout.superAdmin")
                }}</b-badge>
              </span>
              <span class="font-size-16 mr-2">
                <b-badge v-if="user.role === 'ADMIN'" variant="danger">{{
                  $t("public.layouts.HomeLayout.admin")
                }}</b-badge>
              </span>
              <span v-if="
                user.organizationRoles && user.organizationRoles.length != 0
              " class="font-size-16">
                <b-badge v-for="(item, index) in user.organizationRoles" :key="index" variant="success">{{
                  item
                }}</b-badge>
              </span>
            </div>
            <router-link v-for="(item, index) in horizontalMenuSetting" :key="index" v-b-toggle="item.title"
              :to="item.link" class="iq-sub-card iq-bg-primary-hover">
              <div class="media align-items-center">
                <div class="rounded iq-card-icon background-typography text-white">
                  <i :class="item.icon"></i>
                </div>
                <div class="media-body ml-3">
                  <h6 class="mb-0">
                    {{ $t(item.i18n) }}
                  </h6>
                  <p class="mb-0 font-size-16">
                    {{ $t(item.i18nSubtitle) }}
                  </p>
                </div>
              </div>
            </router-link>
            <div class="d-inline-block w-100 text-center p-3">
              <a class="iq-bg-danger iq-sign-btn" href="javascript:void(0)" role="button" @click="logout">
                {{ $t("public.layouts.HomeLayout.exit") }}
                <i class="ri-login-box-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </li>
  </b-collapse>
</template>

<script>
import List from "./ListStyle";
import { xray } from "../../../config/pluginInit";

import { mapActions, mapGetters } from "vuex";

import utilsService from "../../../services/utils";
import userService from "../../../services/user";

export default {
  name: "List",
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  data() {
    return {
      user: undefined,
    }
  },
  props: {
    items: Array,
    className: { type: String, default: "iq-menu" },
    horizontal: Boolean,
    open: { type: Boolean, default: false },
    idName: { type: String, default: "sidebar" },
    accordianName: { type: String, default: "sidebar" },
    user: Object,
    wallet: Object,
    horizontalMenuSetting: Array,
  },
  components: {
    List,
  },
  mounted() {
    this.getUser();
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    logout() {
      utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });
    },
    activeLink(item) {
      return xray.getActiveLink(item, this.$route.name);
    },
    showWallet() {
      this.$router.push({ name: "auth.patient.wallet" });
    },
  },
};
</script>
